export const BETTER_IN_APP_EXPERIMENT = 'aud_mobile_aud3092_better_in_app';

export const EXPERIMENTS: string[] = [BETTER_IN_APP_EXPERIMENT];
